<template>
  <div style="margin-bottom: 15px;" v-if="app_info && app_info.app_id">
    <My-Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="st-title py-10"><span class="st-prefix mr-5"></span>版本信息</div>
    <div class="bordered bg-white mr-10 radius-sm py-30">
      <div class="m-10">
        <div class="flex py-10 items-center">
          <span class="font-bold w-120 text-right" style="flex-shrink: 0;">版本信息：</span>
          <div class="flex w-full items-center" style="justify-content: space-between;">
            <span class="ml-10" v-if="app_program">{{ app_program.program_version }}</span>
            <span class="ml-10" v-else>暂无版本信息</span>
            <div>
              <a-button class="mr-10" :loading="act_loading" v-if="!app_program || app_program.status!=programStatus.WaitToAudit" @click="doMiniappCommit">提交代码</a-button>
              <a-button class="mr-10" v-if="app_program && app_program.status==programStatus.WaitToSubmitAudit" @click="showAuditModal=true">提交审核</a-button>
              <a-button :loading="audit_loading" v-if="app_program && app_program.status==programStatus.WaitToAudit" @click="undoAudit">撤回审核</a-button>
              <a-button :loading="release_loading" v-if="app_program && app_program.status==programStatus.AuditSuccess" @click="doMiniappRelease">发布上线</a-button>
            </div>
          </div>
        </div>
        <div v-if="app_program">
          <div class="flex py-10">
            <span class="font-bold w-120  text-right">创建时间：</span>
            <span class="ml-10">{{ app_program.created_at }}</span>
          </div>
          <div class="flex py-10">
            <span class="font-bold w-120  text-right">状态：</span>
            <span class="ml-10">{{ app_program.status_text }}</span>
          </div>
          <div class="flex py-10 items-center" v-if="app_program.reason">
            <div class="ml-10" style="margin-left:130px;">
              <span class="ml-10" v-html="app_program.reason"></span>
            </div>
          </div>
          <div class="flex py-10 items-center" v-if="online_qrcode">
            <div class="font-bold w-120  text-right">小程序码：</div>
            <div class="ml-10">
              <img width="150" height="150" :src="online_qrcode">
            </div>
          </div>
          <div class="flex py-10 items-center" v-else-if="qrcode">
            <div class="font-bold w-120  text-right">体验码：</div>
            <div class="ml-10">
              <img width="150" height="150" :src="qrcode">
            </div>
          </div>
        </div>
      </div>
      <a-modal
        title="版本描述"
        :visible="showAuditModal"
        :confirm-loading="audit_loading"
        @ok="doMiniappAudit"
        okText="提交审核"
        @cancel="showAuditModal=false"
      >
      <a-textarea
        v-model="version_desc"
        placeholder="请输入版本描述"
        :auto-size="{ minRows: 3, maxRows: 5 }"
      />
      </a-modal>
    </div>
    <div class="st-title py-10"><span class="st-prefix mr-5"></span>基础信息</div>
    <div class="bordered bg-white mr-10 radius-sm py-30" v-if="app_info">
      <div class="m-10">
        <div class="flex py-20 border-b items-center">
          <span class="font-bold w-120 text-right">小程序名称：</span>
          <div class="flex w-full items-center" style="justify-content: space-between;">
            <span class="ml-10">{{app_info.nick_name}}</span>
            <div>
              <a-button class="mr-10" :loading="act_loading" @click="unbind">解除授权</a-button>
            </div>
          </div>
        </div>
        <div class="flex py-20 items-center  border-b">
          <span class="font-bold w-120  text-right">小程序头像：</span>
          <div class="ml-10">
            <img :src="app_info.head_img" width="50" alt="">
          </div>
        </div>
        <div class="flex py-20  border-b">
          <span class="font-bold w-120  text-right">公司名称：</span>
          <span class="ml-10">{{app_info.principal_name}}</span>
        </div>
        <div class="flex py-20 items-center  border-b">
          <div class="font-bold w-120  text-right">小程序AppID：</div>
          <span class="ml-10">{{app_info.app_id}}</span>
        </div>
        <div class="flex py-20 items-center  border-b">
          <div class="font-bold w-120  text-right">授权时间：</div>
          <span class="ml-10">{{app_info.created_at}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="flex items-center justify-center h-full" v-else>
    <a-spin v-if="loading"/>
    <div class="bordered border-gray shadow-sm w-450 py-30 px-15 radius-sm bg-white" v-if="!app_info">
      <div class="flex justify-center">
        <div class="bordered radius-sm">
          <a-icon type="api" style="font-size:80px"/>
        </div>
      </div>
      <div class="text-center text-lg font-medium mt-10">授权已认证小程序</div>
      <div class="flex mt-10">
        <div class="w-80" style="flex-shrink: 0;">适用场景</div>
        <div>已注册的企业主体微信小程序并完成微信认证</div>
      </div>
      <div class="flex mt-10 flex-wrap">
        <div class="w-80" style="flex-shrink: 0;">授权流程</div>
        <div>扫码后把所有权限统一授权，完成后快速发布上线即可获得食堂智慧小程序</div>
      </div>
      <div class="flex mt-15">
        <a-button block @click="getMiniappbindUrl">
          立即授权
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getAppInfo, getAuthUrl, miniappUnbind, miniappCommit, miniappAudit, miniappRelease, appProgramUndoAudit, appProgramAuditStatus } from "@/request/api";
import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";
export default {
  data() {
    return {
      //传给MyBreadcrumb的参数
      breadcrumbs: [
        {
          key: 0,
          title: "微信小程序",
        },
      ],
      app_info:{},
      qrcode: undefined,
      online_qrcode: undefined,
      app_program: {},
      loading: false,
      programStatus:{
        WaitToSubmitAudit: 0,
        WaitToAudit: 1,
        AuditSuccess: 2,
        AuditFail: 3,
        UndoAudit: 4,
        Online: 5,
      },
      act_loading: false,
      audit_loading: false,
      version_desc: undefined,
      release_loading: false,
      mainH: window.innerHeight - 80,
      showAuditModal: false
    };
  },
  name: "MiniappIndex",
  mounted() {},
  components: { MyBreadcrumb },
  created() {
    this.getAppInfoDetail()
  },
  methods: {
    getAppInfoDetail(){
      this.loading = true
      getAppInfo().then(res=>{
        let result = res.data.result;
        this.app_info = result.app_info;
        this.qrcode = result.qrcode;
        this.online_qrcode = result.online_qrcode;
        this.app_program = result.app_program;
        if(this.app_program && this.app_program.status==1){
          appProgramAuditStatus({id:this.app_program.id}).then(res=>{
            let tmp = res.data.result
            if(tmp.status && tmp.status!=this.app_program.status){
              this.getAppInfoDetail()
            }
          })
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    getMiniappbindUrl(){
      getAuthUrl().then(res=>{
        let url = res.data.result
        if(!!url){
          window.open(url);
        }
      })
    },
    doMiniappCommit(){
      let th = this;
      th.act_loading = true
      miniappCommit().then((res)=>{
        th.getAppInfoDetail()
        this.$message.success('操作成功');
      }).finally(()=>{
        this.act_loading = false
      })
    },
    doMiniappAudit(){
      let th = this
      th.audit_loading = true
      miniappAudit({version_desc: this.version_desc}).then((res)=>{
        th.getAppInfoDetail()
        th.$message.success('操作成功');
        th.showAuditModal = false
      }).finally(()=>{
        th.audit_loading = false
      })
    },
    doMiniappRelease(){
      let th = this
      th.release_loading = true
      miniappRelease().then((res)=>{
        th.getAppInfoDetail()
        th.$message.success('操作成功');
      }).finally(()=>{
        th.release_loading = false
      })
    },
    undoAudit(){
      let th = this
      th.audit_loading = true
      appProgramUndoAudit().then((res)=>{
        th.getAppInfoDetail()
        th.$message.success('操作成功');
      }).finally(()=>{
        th.audit_loading = false
      })
    },
    unbind(){
      this.$confirm({
        content: `解除授权将影响食堂正常的使用（更换小程序将无法使用原来的人员信息），您确定解除授权吗？`,
        onOk: () => {
          miniappUnbind().then(res=>{
            if(res>0){
              th.getAppInfoDetail()
              th.$message.success('操作成功');
            }
          })
        },
      });
    }
  }
}
</script>
<style scoped lang="less">
  @import '~@/style/style.less';  
  
</style>